import { StepName } from '@store/step-forms/step.interface';

export const InitTicketLimitPerEmailAddressValidationTrigger = {
  Initialization: 'Initialization',
  TicketAssignmentStepSetToVisible: 'TicketAssignmentStepSetToVisible',
  BookedTariffsCountChangeOrIsBuyerInformationStep: 'BookedTariffsCountChangeOrIsBuyerInformationStep',
  TicketAssignmentFormsCountChanged: 'TicketAssignmentFormsCountChanged',
  SelectedTariffUuidChanged: 'SelectedTariffUuidChanged',
  SelectedTicketHolderUuidChanged: 'SelectedTicketHolderUuidChanged',
  TicketHolderAssignedToMultipleFormsUnassignedFromForm: 'TicketHolderAssignedToMultipleFormsUnassignedFromForm'
} as const;

export const DisableValidationOnSelectedSteps = [StepName.Confirmation, StepName.Invoice, StepName.Recipe] as const;
